var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PublishedItem,{attrs:{"item":_setup.history},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c(_setup.HistoryView,{attrs:{"id":_vm.id}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }